<template>
  <modal :show="show" @close="close" id="user-create">
    <div class="modal-head">
      <h3>Add User</h3>
    </div>
    <div class="modal-content">
      <form @submit.prevent="save">
        <div class="form-control-group">
          <div class="form-control">
            <label for="first-name">First name</label>
            <input
              v-model="input.first_name"
              v-validate="'required'"
              name="first_name"
              data-vv-as="first name"
              id="first-name"
              type="text"
            />
            <div
              v-show="errors.has('first_name')"
              class="validation-error"
            >{{ errors.first('first_name') }}</div>
          </div>

          <div class="form-control">
            <label for="last-name">Last Name</label>
            <input
              v-model="input.last_name"
              v-validate="'required'"
              data-vv-as="last name"
              name="last_name"
              id="last-name"
              type="text"
            />
            <div
              v-show="errors.has('last_name')"
              class="validation-error"
            >{{ errors.first('last_name') }}</div>
          </div>
        </div>

        <div class="form-control">
          <label for="email">Email</label>
          <input
            v-model="input.email"
            v-validate="'required|email'"
            name="email"
            id="email"
            type="text"
          />
          <div v-show="errors.has('email')" class="validation-error">{{ errors.first('email') }}</div>
        </div>

        <div class="form-control-group">
          <div class="form-control">
            <label for="department">Department</label>
            <select
              v-model="input.department_id"
              v-validate="'required'"
              name="department"
              id="department"
            >
              <option v-for="department in departments" :value="department.id">{{ department.name }}</option>
            </select>
            <div
              v-show="errors.has('department')"
              class="validation-error"
            >{{ errors.first('department') }}</div>
          </div>

          <div class="form-control">
            <label for="role">Role</label>
            <select v-model="input.role_id" v-validate="'required'" name="role" id="role">
              <option v-for="role in roles" :value="role.id">{{ role.name }}</option>
            </select>
            <div v-show="errors.has('role')" class="validation-error">{{ errors.first('role') }}</div>
          </div>
        </div>

        <div class="form-control">
          <label for="title">Title</label>
          <input v-model="input.title" v-validate="'required'" name="title" id="title" type="text" />
          <div v-show="errors.has('title')" class="validation-error">{{ errors.first('title') }}</div>
        </div>

        <div class="form-control">
          <label for="phone">Phone</label>
          <input v-model="input.phone" id="phone" type="text" />
        </div>

        <div class="form-control">
          <label for="password">Password</label>
          <input
            v-model="input.password"
            v-validate="'required'"
            name="password"
            id="password"
            type="password"
            ref="password"
          />
          <div
            v-show="errors.has('password')"
            class="validation-error"
          >{{ errors.first('password') }}</div>
        </div>

        <div class="form-control">
          <label for="password-confirm">Confirm Password</label>
          <input
            v-model="input.password_confirm"
            v-validate="'required|confirmed:password'"
            data-vv-as="password"
            name="password_confirm"
            id="password-confirmation"
            type="password"
          />
          <div
            v-show="errors.has('password_confirm')"
            class="validation-error"
          >{{ errors.first('password_confirm') }}</div>
        </div>

        <button class="button button-green">Save</button>
        <button @click.prevent="close" class="button">Cancel</button>
      </form>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/ui/Modal";

export default {
  name: "UserCreate",
  props: ["show"],
  components: {
    Modal
  },
  created() {
    this.loadRoles();
    this.loadDepartments();
  },
  data() {
    return {
      input: {},
      roles: [],
      departments: []
    };
  },
  methods: {
    loadRoles() {
      this.$http
        .get("/roles")
        .then(response => {
          this.roles = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    loadDepartments() {
      this.$http
        .get("/departments")
        .then(response => {
          this.departments = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async save() {
      let valid = await this.$validator.validateAll();
      if (!valid) {
        return false;
      }

      this.$http
        .post("/users", this.input)
        .then(response => {
          this.$emit("update");
          this.$emit("close");
        })
        .catch(error => {
          console.log(error);
        });
    },
    close() {
      this.$emit("close");
      this.input = {};
    }
  }
};
</script>

<style lang="scss">
#user-create {
}
</style>
